import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';

/**
 * Component is used to render iFrame and communicate with that iFrame, communication reference can be
 * found at
 * - https://developer.mobilexpress.com.tr/api-reference/hosted-payment-gateway/hostedpaymentgateway-starthostedpaymentprocess
 *
 * @attr [format] - String used to format date, check MomentJs documentation for information
 * @attr [class-modifier] - String, additional css class that would be added to the button
 * Example
 * <e2-payment-frame
 * src-url="iFrameUrl"              URL which need to open in Iframe
 * return-url=""                    URL to return when transition gets successful
 * errorLabel = ""                  Generic Error label
 * validation-error-label=""        Validation error label
 *  ></e2-payment-frame>
 */
class PaymentIFrame extends SimpleLitElement {
    static get properties() {
        return {
            srcUrl: { type: String, attribute: 'src-url' },
            returnUrl: { type: String, attribute: 'return-url' },
            validationErrorLabel: { type: String, attribute: 'validation-error-label' },
            errorLabel: { type: String, attribute: 'error-label' },
            showError: { type: Boolean, attribute: false },
            errorMsg: { type: String, attribute: false },
            hideLoader: { type: Boolean, attribute: false },
        };
    }

    constructor() {
        super();
        this.srcUrl = '';
        this.showError = false;
        this.errorMsg = '';
        this.hideLoader = false;
    }

    firstUpdated() {
        window.addEventListener('message', this.checkValid, false);
        window.document.addEventListener('paymentCompleted', this.checkAndNavigate, false);
    }

    checkAndNavigate = event => {
        const token = event.detail.token;
        let urlToSend = `${this.returnUrl}&Result=${event.detail.Result}&Hash=${event.detail.Hash}&TotalAmount=${event.detail.TotalAmount}`;
        if (!this.returnUrl.includes(token)) {
            const index = urlToSend.indexOf('=') + 1;
            urlToSend = urlToSend.substring(0, index) + null;
        }
        window.location.href = urlToSend;
        false;
    };

    toggleError = (msg, show) => {
        this.errorMsg = msg;
        this.showError = show;
    };

    checkValid = event => {
        if (event.data && event.data.message) {
            switch (event.data.message) {
                case 'ValidationError':
                    this.toggleError(this.validationErrorLabel, true);
                    break;
                case 'ErrorOccurred':
                    this.toggleError(this.errorLabel, true);
                    break;
                case 'HeightChanged':
                case 'AmountChanged':
                case 'ProceedToPaymentResult':
                case 'PaymentStarted':
                case 'CardSaved':
                    this.toggleError(this.errorLabel, false);
                    break;
                default:
                    break;
            }
        }
        return false;
    };

    hideSpinner = () => {
        this.hideLoader = true;
    };

    renderError = () => {
        if (this.showError) {
            return html`
                <e2-message type="error">
                    <div v-slot="message">${this.errorMsg}</div>
                </e2-message>
            `;
        }
        return null;
    };

    render() {
        return this.srcUrl !== ''
            ? html`
                  <div class="payment-container">
                      ${this.hideLoader
                          ? ''
                          : html`
                                <e2-loading
                                    ?hide-loading-icon="${this.hideLoader}"
                                    ?show-loading-icon="${!this.hideLoader}"
                                >
                                </e2-loading>
                            `}

                      <div class="payment-container-frame">
                          ${this.renderError()}
                          <iframe
                              class="payment-container__frame"
                              id="payment-iFrame"
                              src="${this.srcUrl}"
                              title="payment-iFrame"
                              @load="${this.hideSpinner}"
                          ></iframe>
                      </div>
                  </div>
              `
            : null;
    }
}

export default () => customElements.define('e2-payment-frame', PaymentIFrame);
